import { LOCALES } from 'i18n/locales';

export const errorSummaryIntl = {
    [LOCALES.ENGLISH]: {
        'ErrorSummary.Problem': 'There is a problem'
    },
    [LOCALES.WELSH]: {
        'ErrorSummary.Problem': 'Mae problem'
    }
};
